export default "__VITE_ASSET__625876d0__"